import { QUILL_PREVIEW_CONTENT_STYLES } from '../../../constants/quillPreviewContentStyles';

export const A4_DOCUMENT_CONTENT_PLACEHOLDER = '{{ content }}';

/** Content area height: 297mm page − 20mm top − 20mm bottom padding. */
export const A4_PAGE_CONTENT_HEIGHT_MM = 257;

const A4_PAGINATION_SCRIPT = `
(function () {
  function mmToPx(mm) {
    var el = document.createElement('div');
    el.style.cssText = 'position:absolute;visibility:hidden;width:' + mm + 'mm';
    document.body.appendChild(el);
    var px = el.getBoundingClientRect().width;
    document.body.removeChild(el);
    return px;
  }

  function isMeaningfulNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      return Boolean(node.textContent && node.textContent.trim());
    }
    return node.nodeType === Node.ELEMENT_NODE;
  }

  function createPage() {
    var page = document.createElement('main');
    page.className = 'page';
    var section = document.createElement('section');
    section.className = 'document-content';
    page.appendChild(section);
    return page;
  }

  var maxPageContentHeightPx = mmToPx(${A4_PAGE_CONTENT_HEIGHT_MM});
  var measureSource = document.getElementById('measure-source');
  var pagesRoot = document.getElementById('pages-root');

  if (!measureSource || !pagesRoot) {
    return;
  }

  var nodes = Array.prototype.slice
    .call(measureSource.childNodes)
    .filter(isMeaningfulNode);

  if (!nodes.length) {
    pagesRoot.appendChild(createPage());
    measureSource.parentNode.removeChild(measureSource);
    return;
  }

  var page = createPage();
  pagesRoot.appendChild(page);
  var section = page.querySelector('.document-content');

  nodes.forEach(function (node) {
    var clone = node.cloneNode(true);
    section.appendChild(clone);

    if (section.scrollHeight > maxPageContentHeightPx) {
      section.removeChild(clone);
      page = createPage();
      pagesRoot.appendChild(page);
      section = page.querySelector('.document-content');
      section.appendChild(clone);
    }
  });

  measureSource.parentNode.removeChild(measureSource);
})();
`;

export const A4_DOCUMENT_TEMPLATE = `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>A4 Document</title>
  <style>
    @page {
      size: A4;
      margin: 20mm 18mm;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    html,
    body {
      margin: 0;
      padding: 0;
      background: #f3f4f6;
      color: #111827;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 11pt;
      line-height: 1.5;
    }

    .pages-root {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      padding: 24px 0 32px;
    }

    .page {
      width: 210mm;
      height: 297mm;
      margin: 0 auto;
      padding: 20mm 18mm;
      background: #ffffff;
      box-shadow: 0 1px 4px rgba(17, 24, 39, 0.08);
      overflow: hidden;
      flex-shrink: 0;
    }

    .page .document-content {
      height: ${A4_PAGE_CONTENT_HEIGHT_MM}mm;
      overflow: hidden;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
    }

    .measure-source {
      position: absolute;
      left: -9999px;
      top: 0;
      visibility: hidden;
      width: calc(210mm - 36mm);
      pointer-events: none;
    }

    .document-content p {
      margin: 0 0 1mm;
      padding: 0;
    }

    .document-content h1,
    .document-content h2,
    .document-content h3,
    .document-content h4,
    .document-content h5,
    .document-content h6 {
      margin: 0 0 1.5mm;
      padding: 0;
    }

    ${QUILL_PREVIEW_CONTENT_STYLES}

    @media print {
      html,
      body {
        background: #ffffff;
      }

      .pages-root {
        gap: 0;
        padding: 0;
      }

      .page {
        width: auto;
        height: auto;
        margin: 0;
        padding: 0;
        box-shadow: none;
        page-break-after: always;
      }

      .page:last-child {
        page-break-after: auto;
      }

      .page .document-content {
        height: auto;
        overflow: visible;
      }
    }
  </style>
</head>
<body>
  <div id="measure-source" class="document-content measure-source">${A4_DOCUMENT_CONTENT_PLACEHOLDER}</div>
  <div id="pages-root" class="pages-root"></div>
  <script>${A4_PAGINATION_SCRIPT}</script>
</body>
</html>`;

export const buildA4PreviewDocument = content =>
  A4_DOCUMENT_TEMPLATE.replace(A4_DOCUMENT_CONTENT_PLACEHOLDER, content || '');
